import React, { useState, useCallback, createContext, useContext } from 'react';
import translations from '../i18n/translations';

const LanguageContext = createContext(null);

export const useLanguage = () => useContext(LanguageContext);

const LANGUAGES = {
  fr: { label: 'Francais', flag: '\u{1F1EB}\u{1F1F7}' },
  en: { label: 'English', flag: '\u{1F1EC}\u{1F1E7}' },
  es: { label: 'Espanol', flag: '\u{1F1EA}\u{1F1F8}' },
  pt: { label: 'Portugues', flag: '\u{1F1E7}\u{1F1F7}' },
  de: { label: 'Deutsch', flag: '\u{1F1E9}\u{1F1EA}' },
  ar: { label: '\u0627\u0644\u0639\u0631\u0628\u064A\u0629', flag: '\u{1F1F8}\u{1F1E6}' },
};

export { LANGUAGES };

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState(localStorage.getItem('alyse_lang') || 'fr');

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('alyse_lang', lang);
  };

  const t = useCallback((key, replacements) => {
    const entry = translations[key];
    if (!entry) return key;
    let text = entry[language] || entry['fr'] || key;
    if (replacements) {
      Object.entries(replacements).forEach(([k, v]) => {
        text = text.replace(`{${k}}`, v);
      });
    }
    return text;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, LANGUAGES, t }}>
      {children}
    </LanguageContext.Provider>
  );
}
